var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.type == 'text')?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }